/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Utilities
import Header from '../../components/header/index'
import Hero from '../../components/heros/index'
import Container from '../../components/container'
import Plan from '../../components/plan'
import Item from '../../components/planItem'
import Primary from '../../components/buttons/primary'
import Features from '../../components/features'
import Location from '../../components/location'
import Panel from '../../components/panel'
import CTO from '../../components/cto'
import Footer from '../../components/footer'
import Title from '../../components/title'

const Minecraft = () => {
    Title('Minecraft Server - StellaNode')
    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='primary' title='Premium Minecraft Hosting' description='Get started by selecting a Minecraft Server plan below' />
            </div>
            <section className="plans py-28">
                <Container>
                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-20 gap-y-16 mb-16">
                        <Plan title='Copper Plan' price='8.00' renewal='monthly' link='minecraft-premium/copper-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='4 GB DDR4 RAM' />
                            <Item title='100 GB NVMe SSD Storage' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Iron Plan' price='12.00' renewal='monthly' link='minecraft-premium/iron-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='6 GB DDR4 RAM' />
                            <Item title='100 GB NVMe SSD Storage' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Gold Plan' price='16.00' renewal='monthly' link='minecraft-premium/gold-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='8 GB DDR4 RAM' />
                            <Item title='100 GB NVMe SSD Storage' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Diamond Plan' price='20.00' renewal='monthly' link='minecraft-premium/diamond-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='10 GB DDR4 RAM' />
                            <Item title='100 GB NVMe SSD Storage' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Emerald Plan' price='24.00' renewal='monthly' link='minecraft-premium/emerald-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='12 GB DDR4 RAM' />
                            <Item title='100 GB NVMe SSD Storage' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Quartz Plan' price='28.00' renewal='monthly' link='minecraft-premium/quartz-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='14 GB DDR4 RAM' />
                            <Item title='100 GB NVMe SSD Storage' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Netherite Plan' price='32.00' renewal='monthly' link='minecraft-premium/netherite-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='16 GB DDR4 RAM' />
                            <Item title='100 GB NVMe SSD Storage' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Proxy Plan' price='3.00' renewal='monthly' link='minecraft-premium/proxy-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='1 GB DDR4 RAM' />
                            <Item title='50 GB NVMe SSD Storage' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                        <Plan title='Crystal Plan' price='128.00' renewal='monthly' link='minecraft-premium/crystal-plan'>
                            <Item title='AMD Ryzen 7 5800X @ 4.7GHz' />
                            <Item title='64 GB DDR4 RAM' />
                            <Item title='400 GB NVMe SSD Storage' />
                            <Item title='Dedicated IP & Server Splitter' />
                            <Item title='1.3 Tbps DDoS Protection' />
                            <Item title='Free Automatic Backups' />
                        </Plan>
                    </div>
                    <div className='bg-primary-light shadow-xl p-8 rounded-md text-center'>
                        <h1 className='text-gray-100 font-medium text-2xl mb-2.5'>Unsure what plan is best for you?</h1>
                        <p className='text-gray-300 mb-7'>Contact us and we will help you pick the right choice for your needs.</p>
                        <div className='flex justify-center'>
                            <Primary rounded='sm' arrow={true} length='sm' link='https://billing.stellanode.com/submitticket.php'>Contact Us</Primary>
                        </div>
                    </div>
                </Container>
            </section>
            <Features />
            <Panel />
            <Location />
            <CTO />
            <Footer />
        </main>
    )
}

export default Minecraft